// ── SMOOTH SCROLL for nav links ──
document.addEventListener('click', function(e) {
  var el = e.target.closest('.nav-scroll');
  if (!el) return;
  var href = el.getAttribute('href');
  if (!href || !href.startsWith('#')) return;
  var target = document.querySelector(href);
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  }
});

// ── CART ──
function openCart() {
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  fetchCart();
}
function closeCart() {
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
}
function fetchCart() {
  fetch('/cart.js').then(r => r.json()).then(renderCart).catch(console.error);
}
function renderCart(cart) {
  var body = document.getElementById('cartBody');
  var footer = document.getElementById('cartFooter');
  var countEl = document.getElementById('cartCount');
  var totalEl = document.getElementById('cartTotal');
  if (!body) return;
  var count = cart.item_count || 0;
  if (countEl) { countEl.textContent = count; countEl.style.display = count > 0 ? 'inline' : 'none'; }
  if (count === 0) {
    body.innerHTML = '<div class="cart-empty"><span class="cart-empty-text">YOUR BAG IS EMPTY</span></div>';
    if (footer) footer.style.display = 'none';
    return;
  }
  if (footer) { footer.style.display = 'block'; if (totalEl) totalEl.textContent = formatMoney(cart.total_price); }
  var html = '';
  cart.items.forEach(function(item) {
    html += '<div class="cart-item" data-key="' + item.key + '">';
    if (item.image) html += '<img class="cart-item-img" src="' + item.image + '" alt="' + item.product_title + '">';
    else html += '<div class="cart-item-img"></div>';
    html += '<div class="cart-item-info">';
    html += '<div class="cart-item-name">' + item.product_title.toUpperCase() + '</div>';
    if (item.variant_title && item.variant_title !== 'Default Title')
      html += '<div class="cart-item-variant">' + item.variant_title.toUpperCase() + '</div>';
    html += '<div class="cart-item-price">× ' + item.quantity + ' &nbsp; ' + formatMoney(item.line_price) + '</div>';
    html += '</div>';
    html += '<button class="cart-item-remove" onclick="removeFromCart(\'' + item.key + '\')">×</button>';
    html += '</div>';
  });
  body.innerHTML = html;
}
function addToCart(variantId, btn) {
  if (btn) { btn.textContent = '...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(r => r.json()).then(function() {
    if (btn) { btn.textContent = 'ADDED'; setTimeout(function() { btn.textContent = 'ADD TO BAG'; btn.disabled = false; }, 1200); }
    openCart();
  }).catch(function() { if (btn) { btn.textContent = 'ADD TO BAG'; btn.disabled = false; } });
}
function removeFromCart(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(r => r.json()).then(renderCart).catch(console.error);
}
function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
function updatePrice(select) {
  var el = document.getElementById('productPrice');
  if (el && select.options[select.selectedIndex]) el.textContent = select.options[select.selectedIndex].dataset.price;
}

// Init cart count
fetch('/cart.js').then(r => r.json()).then(function(cart) {
  var el = document.getElementById('cartCount');
  if (el && cart.item_count > 0) { el.textContent = cart.item_count; el.style.display = 'inline'; }
}).catch(function(){});
